<template>
    <span class="box" v-if="simpleText">{{boxString == "" ? "No artist": boxString}}</span>
    <span v-else-if="displayBagdes" class="box-badge-container" @click.prevent="onClick">
        <span v-if="boxes != null" v-for="box in boxes" :key="box.name" class="badge box-badge">
          <span class="name">{{box.name}}</span>
        </span>
    </span>
    <input v-else type="text" readonly placeholder="Boxes" :value="boxString" :class="!boxString || boxString.length === 0 ? 'is-empty' : ''" @click.prevent="onClick"/>
</template>

<script>
    export default {
      name: "BoxesBadgeList",
      props: {
        boxes: [Array, String],
        displayBagdes: { type: Boolean, default: false },
        simpleText: { type: Boolean, default: false }
      },
      computed: {
        boxString() {
          console.log('0000000000' ,this.boxes)
          if (!this.boxes || this.boxes.length === 0) {
            return '';
          }

          var boxesName = this.boxes.map(x =>  x.name);
          return boxesName.join(', ');
        }
      },
        methods: {
        onClick(event) { this.$emit("click", event); }
      }
    }
</script>

<style scoped>
    .box-badge-container {
        white-space: nowrap;
        text-overflow: ellipsis;
        border-bottom: 1px solid #d2d2d2;
        height: 30px;
        display: block;
    }

    .box-badge-container:hover {
        border-bottom: 1px solid #18B9E7;
        cursor: pointer;
    }

    .box-badge {
        background: #18B9E7;
        border-radius: 100px;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        padding: 5px 10px;
        color: white;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        margin: 0 5px;
    }

    .box-badge.hidden {
        background: #d2d2d2;
    }

    .box-badge .name {
        width: 100%;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 0 1em;
    }

    input[type=text] {
        text-overflow: ellipsis;
        cursor: pointer;
    }

    input [type=text]:focus {
        background: transparent;
    }
</style>
